import { smoothScroll } from '@gn-audio/ui/tools/smooth-srcoll';
import { isMobile } from 'src/Foundation/Design/platform';

const condensedMenuElement: HTMLElement | null = document.querySelector('.condensed-menu__content');

export const scrollToTarget = (element: HTMLElement | null): void => {
  if (element) {
    smoothScroll(element, { offset: isMobile ? 0 : condensedMenuElement?.clientHeight || 0 });
  }
};